import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20artistic%20composition%20with%20flowing%20organic%20shapes%20in%20coral%20amber%20and%20cream%20tones%20soft%20gradients%20and%20gentle%20curves%20modern%20minimal%20aesthetic%20editorial%20quality%20high%20resolution%20smooth%20textures%20harmonious%20color%20blend&width=1600&height=900&seq=hero-bg-main-001&orientation=landscape"
          alt="打屁股视频大全 - 热门合集在线观看"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      <div className="absolute inset-0 flex items-center justify-center px-4">
        <div className="text-center max-w-3xl w-full">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
            打屁股视频大全
          </h1>
          <p className="text-background-50/90 text-base md:text-lg mb-6 max-w-2xl mx-auto leading-relaxed">
            {siteInfo.tagline}，涵盖亲子教育场景、影视经典片段、搞笑整蛊视频、校园趣事等多元化分类，高清在线观看，每日更新精选内容
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/funny-prank-videos"
              className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line mr-2"></i>
              开始观看
            </Link>
            <Link
              to="/category/movie-classic-clips"
              className="w-full sm:w-auto px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-fire-line mr-2"></i>
              热门推荐
            </Link>
          </div>
          <div className="flex items-center justify-center gap-6 mt-8">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-accent-500">{siteInfo.stats.totalVideos}+</div>
              <div className="text-background-50/70 text-xs mt-1">精选视频</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-accent-500">{siteInfo.stats.totalCategories}</div>
              <div className="text-background-50/70 text-xs mt-1">内容分类</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-accent-500">{(siteInfo.stats.totalViews / 10000).toFixed(0)}万+</div>
              <div className="text-background-50/70 text-xs mt-1">累计播放</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}